"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureManager = void 0;
var clone_ts_1 = require("./utility/clone-ts");
/**
 * Feature manager
 */
var FeatureManager = /** @class */ (function () {
    /**
     * Creates a new instance of the FeatureManager.
     * @param {FeatureMap} feats - A set of features and whether or not they are enabled and/or testable.
     * @param {LibraryFeatureMap} libraryConfigurations - A set of features enabled for a library.
     * @param {number} tenant - The tenant id.
     * @param {AllFeatures} allFeatures - The allFeatures secret cookie value. This should be '0' for off or '1' for on.
     */
    function FeatureManager(feats, libraryConfigurations, tenant, allFeatures) {
        this.libraryConfigurations = libraryConfigurations;
        this.useTestable = this.shouldUseTestable(tenant, allFeatures);
        this.features = (0, clone_ts_1.lightClone)(feats);
    }
    /**
     * Feature manager method for determining whether or not to show a feature.
     * This is the single source of truth for permissions.
     * @method
     * @param {FeatureName} feature - The feature in question
     * @returns {boolean}
     */
    FeatureManager.prototype.isEnabled = function (feature) {
        return !!(this.isOkForLibrary(feature) &&
            (this.useTestable
                ? this.isStrictlyTestable(feature)
                : this.isStrictlyEnabled(feature)));
    };
    /**
     * Feature manager method returning the strictly `enabled` value.
     * Note: due to dynamic configurations, this should not be assumed to be
     * the config/features.json `enabled` value, though that is the default.
     * @param {FeatureName} feature - The feature to lookup
     * @returns {boolean}
     */
    FeatureManager.prototype.isStrictlyEnabled = function (feature) {
        return this.features[feature] && this.features[feature].enabled;
    };
    /**
     * Feature manager method returning the strictly `testable` value.
     * Note: due to dynamic configurations, this should not be assumed to be
     * the config/features.json `enabled` value, though that is the default.
     * @param {FeatureName} feature - The feature to lookup
     * @returns {boolean}
     */
    FeatureManager.prototype.isStrictlyTestable = function (feature) {
        return this.features[feature] && this.features[feature].testable;
    };
    /**
     * Private method returning whether libraryConfigurations permits this feature.
     * @param {FeatureName} feature - The feature in question
     * @returns {boolean}
     */
    FeatureManager.prototype.isOkForLibrary = function (feature) {
        var libFeat = this.libraryConfigurations[feature];
        return !libFeat || libFeat.enabled || false;
    };
    /**
     * Private method returning whether to use the config/features.json
     * `enabled` or `testable` value.
     * @param {number} tenant - The tenant id
     * @param {string} allFeatures - The allFeatures secret cookie value
     * @returns {boolean}
     */
    FeatureManager.prototype.shouldUseTestable = function (tenant, allFeatures) {
        return (tenant === 100501 ||
            tenant === 100300 ||
            (tenant >= 800000 && tenant < 900000) ||
            allFeatures === '1');
    };
    return FeatureManager;
}());
exports.FeatureManager = FeatureManager;

//# sourceMappingURL=featureManager-ts.js.map

//# sourceMappingURL=featureManager-ts.js.map
